import GradesModal from '../Modals/GradesModal'
import HighlightedPickersModal from '../Modals/HighlightedPickersModal'

export const PICKERS_MODALS = {
  recommended_variants: HighlightedPickersModal,
  grades: GradesModal,
}

// When a picker from this group is selected, its `emphasis`
// value overrides the colors of all selected pickers
export const PICKER_GROUP_WITH_THEME = 'recommended_variants'
